<template>
  <div id="cyber-background">
    <div class="cyber-grid"></div>
    <div class="scanlines"></div>
    <div class="vignette"></div>
  </div>
</template>

<script>
export default {
  name: "ParticlesBackground",
};
</script>

<style scoped>
#cyber-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 0;
  pointer-events: none;
  background-color: var(--bg-primary);
}

/* Subtle Tech/Schematic Grid */
.cyber-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(0, 240, 255, 0.05) 1px,
      transparent 1px),
    linear-gradient(90deg, rgba(0, 240, 255, 0.05) 1px, transparent 1px);
  background-size: 50px 50px;
  background-position: center center;
  opacity: 0.8;
}

/* CRT Hacker Scanlines Effect */
.scanlines {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0) 50%,
      rgba(0, 0, 0, 0.2) 50%,
      rgba(0, 0, 0, 0.2));
  background-size: 100% 4px;
  opacity: 0.4;
  animation: scanline-scroll 20s linear infinite;
}

/* Vignette to darken edges and make text pop */
.vignette {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at center,
      transparent 20%,
      var(--bg-primary) 100%);
}

@keyframes scanline-scroll {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: 0 100vh;
  }
}
</style>
